<template>
    <div class="video_page" >
        <Wp_nav_bar title="视频播放"></Wp_nav_bar>
        <div style="padding: 10px; font-size: 16px">
            {{this.title}}
        </div>
        <div style="padding: 5px 0px; background-color: #000000">
            <Wp_video_player ref="video_player" :width="$common.screenWidth + 'px'"
                             :height="$common.screenWidth + 'px'"
                             ratio="1:1"
                             :auto-play="auto_play"
                             :url="play_url"
                             @onPlayerPlay="onPlayerPlay"
                             :fullscreen="true"
                             :no-audio="false"
            ></Wp_video_player>
        </div>

    </div>
</template>

<script>
    import Wp_video_player from "./Wp_video_player";
    import Wp_nav_bar from "./Wp_nav_bar";
    import {Dialog} from 'vant';
    export default {
        name: "Wp_video_page",
        components: {Wp_nav_bar, Wp_video_player},
        data(){
            return{
                auto_play: false,
                play_url: '',
                title: ''
            }
        },
        // computed: {
        //     player() {
        //         return this.$refs.videoPlayer.player
        //     }
        // },

        created() {
            this.initVideoUrl();

        },

        methods:{
            initVideoUrl(){
                let _url = this.$route.query.url;
                if(_url){
                    this.play_url = decodeURIComponent(_url);
                }
                let _title = this.$route.query.title;
                if(_title){
                    this.title = decodeURIComponent(_title);
                }
            },

            onPlayerPlay(event){
                this.$log(event)
                // let player = event;
            },
        }
    }
</script>

<style scoped>
    .video_page{
        /*background-color: #000000;*/
    }
</style>